export const normalizeMbi = (value: unknown): string =>
  typeof value === 'string' ? value.replace(/[^A-Za-z0-9]/g, '').toUpperCase() : '';
